"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//

exports.default = {
  props: ["heading", "text", "unit", "icon", "big", "url"],

  computed: {
    classes: function classes() {
      return this.big ? "big" : "";
    }
  },

  methods: {
    redirect: function redirect() {
      window.location.href = this.url;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/cards/DashboardCard.vue
// module id = ojnT
// module chunks = 0 1